import { render } from "./SCR060.vue?vue&type=template&id=efb9d4a4"
import script from "./SCR060.vue?vue&type=script&lang=ts"
export * from "./SCR060.vue?vue&type=script&lang=ts"
script.render = render

export default script